module.exports = __webpack_public_path__ + "static/img/warehouse07.41497d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse07.jpg
// module id = IbOC
// module chunks = 0